import React, { ChangeEvent, useState, useEffect } from 'react';
import { FormControl, FormLabel, RadioGroup, Radio, Box } from '@mui/material';
import { RadioOption } from '../../../../../components/radio-group';
import { RepresentationTypeValue } from './utils';

interface IRepresentationTypeComponentProps {
  representationType?: RepresentationTypeValue;
  isRepresented?: boolean;
  isReadOnly: boolean;
  onRepresentationTypeChange: (name: string, value?: RepresentationTypeValue) => void;
}

export function RepresentationTypeComponent(props: IRepresentationTypeComponentProps) {
  const { representationType, onRepresentationTypeChange, isRepresented, isReadOnly } = props;

  const [isActive, setIsActive] = useState<RepresentationTypeValue>('none');

  useEffect(() => {
    if (isRepresented === false || representationType === undefined) {
      setIsActive('none');
      onRepresentationTypeChange('representationType', undefined);
      return;
    }
    setIsActive(representationType);
  }, [representationType, isRepresented, onRepresentationTypeChange]);

  function handleRepresentationTypeChange(_: ChangeEvent<HTMLInputElement>, value: string) {
    const typedValue = value as RepresentationTypeValue;
    setIsActive(typedValue);
    onRepresentationTypeChange('representationType', typedValue);
  }

  return isRepresented ? (
    <FormControl component="fieldset" sx={{ paddingLeft: 1.7 }}>
      <FormLabel id="representationType-radios" component="legend">
        Type af repræsentation
      </FormLabel>

      {!isReadOnly ? (
        <RadioGroup aria-labelledby="representationType-radios" name="representationType" value={isActive} onChange={handleRepresentationTypeChange}>
          <RadioOption value="accompanyingPerson" control={<Radio />} label="Bisidder" />
          <RadioOption value="authorizedRepresentative" control={<Radio />} label="Partsrepræsentant" />
        </RadioGroup>
      ) : (
        <Box sx={{ fontSize: '0.875em' }}>{getRepresentationTypeDisplay(isActive)}</Box>
      )}
    </FormControl>
  ) : (
    <span />
  );
}

function getRepresentationTypeDisplay(value: RepresentationTypeValue) {
  switch (value) {
    case 'accompanyingPerson':
      return 'Bisidder';
    case 'authorizedRepresentative':
      return 'Partsrepræsentant';
    case 'none':
      return 'Ikke valgt';
    default:
      return 'Ikke valgt';
  }
}
